import Vue from 'vue'
import Vuex from 'vuex'
import { firestorePlugin } from 'vuefire'
import * as firebase from 'firebase/app'
import 'firebase/database'
import _ from 'lodash'

// explicit installation required in module environments
Vue.use(firestorePlugin)
Vue.use(Vuex)

let config = {
  live: {
    apiKey: 'AIzaSyBMt_qn3A_HQVITEQ2g1FAjH-s1mtUsOOw',
    authDomain: 'okl01-live.firebaseapp.com',
    databaseURL: 'https://okl01-live.firebaseio.com',
    projectId: 'okl01-live',
    storageBucket: 'okl01-live.appspot.com',
    messagingSenderId: '303236526857'
  },
  dev: {
    apiKey: 'AIzaSyDe_FRNyFxqO36UiluBR5-NZUFQywpx_Sk',
    authDomain: 'okl01-dev.firebaseapp.com',
    databaseURL: 'https://okl01-dev.firebaseio.com',
    projectId: 'okl01-dev',
    storageBucket: 'okl01-dev.appspot.com',
    messagingSenderId: '971798880037'
  }
}

// Set default config to live
let activeConfig = config.live

// Only set config to dev settings if we're on localhost
if (window.location.host.indexOf('localhost') !== -1) {
  activeConfig = config.dev
}

firebase.initializeApp(activeConfig)
let db = firebase.database()
let store = new Vuex.Store({
  state: {
    beersTested: 0,
    beerTastings: 0,
    breweriesCount: 0,
    breweriesData: [],
    data: {},
    dateKey: '',
    detailedData: {},
    detailedDataIsLoading: true,
    isLoading: true,
    rateBeers: '',
    raterName: false,
    raters: [],
    uniqueBreweries: []
  },
  getters: {
    getSystemetDataByNr: (state) => (nr) => {
      let result = _.find(state.systemetData.data, function (item) {
        return parseInt(item.nr) === parseInt(nr)
      })
      return result
    },
    getDetailedDataByNr: (state) => (nr) => {
      let result = _.find(state.detailedData, function (item) {
        return parseInt(item.nr) === parseInt(nr)
      })
      return result
    },
    getDetailedDataIsLoading: (state) => state.detailedDataIsLoading,
    rateBeers: state => state.rateBeers,
    raterName: state => state.raterName,
    data: state => state.data,
    dateKey: state => state.dateKey,
    raters: state => getUniqueRaters(state.data),
    beersCount: state => state.beersTested,
    breweriesCount: state => state.breweriesCount,
    fridaysCount: state => state.beerTastings,
    isLoading: state => state.isLoading,
    breweriesData: state => state.breweriesData
  },
  mutations: {
    CREATE_APP_DATA (state, data) {
      const breweries = filterUniqueBreweries(data)
      const reorderedData = reorderData(data)

      state.beerTastings = Object.keys(data).length
      state.beersTested = countNumbersOfBeers(data)
      state.breweriesCount = breweries.length
      state.breweriesData = createBreweriesData(reorderedData)
      state.data = reorderedData
      state.uniqueBreweries = breweries
    },
    SET_RATING_LIST (state, beersData) {
      let sessions = beersData
      let dates = []
      let beers = []

      for (let key in sessions) {
        dates.push(key)
      }

      // Sort so we have latest first
      dates.sort(function (a, b) { return b - a })

      // Set dateKey so we can use it to push data to firebase
      state.dateKey = dates[0]

      // Extract beer names into beers list
      for (let beer in sessions[dates[0]]) {
        let name = sessions[dates[0]][beer].name
        let ratings = sessions[dates[0]][beer].ratings
        let image = sessions[dates[0]][beer].img
        let brewery = sessions[dates[0]][beer].brewery
        let systembolagetNr = parseInt(sessions[dates[0]][beer].systembolagetNr)
        let average = []

        // Get the ratings out to an array
        _.find(ratings, function (obj) {
          average.push(obj.rating)
        })

        // Calculate average and set to NaN if no ratings available
        average = calculateAverage(average)
        beers.push({
          id: beer,
          name: name,
          average: average,
          image: image,
          brewery: brewery,
          systembolagetNr: systembolagetNr
        })
      }

      state.rateBeers = beers
    },
    UPDATE_RATER_NAME (state, name) {
      state.raterName = name
    },
    SET_DATA (state, data) {
      state.data = reorderData(data)
      state.isLoading = false
    },
    UPDATE_DATE_KEY (state, dateKey) {
      state.dateKey = dateKey
    },
    UPDATE_DETAILED_DATA (state, data) {
      state.detailedData[data.nr] = data
    }
  },
  actions: {
    loadData ({ commit }) {
      let dataRef = db.ref('data')
      dataRef.on('value', data => {
        let data3ol3 = data.val()

        const sortedData = {}
        Object.keys(data3ol3).sort(function (a, b) {
          return b - a
        }).forEach(function (key) {
          sortedData[key] = data3ol3[key]
        })

        commit('CREATE_APP_DATA', sortedData)
      })
    },
    loadDetailedData ({ commit, state }, id) {
      if(state.detailedData[id]) return

      let ref = db.ref('systembolaget/' + id)
      // once, don't listen for changes only get data
      ref.once("value")
        .then(function(snapshot) {
          commit('UPDATE_DETAILED_DATA', snapshot.val())
        })
    },
    loadRatingList ({ commit }) {
      let dataRef = db.ref('data')
      dataRef.limitToLast(1).on('value', data => {
        commit('SET_RATING_LIST', data.val())
      })
    },
    addRating ({commit}, rateData) {
      let path = rateData.dateKey + '/' +
      rateData.beerId +
      '/ratings/' +
      rateData.name

      let dataRef = db.ref('data/' + path)
      dataRef.set({name: rateData.name, rating: rateData.rating})
    },
    setRaterName ({ commit }, name) {
      commit('UPDATE_RATER_NAME', name)
    },
    setDateKey ({ commit }, dateKey) {
      commit('UPDATE_DATE_KEY', dateKey)
    },
    createNewData ({ commit }, newBeerData) {
      let dateKey = Date.parse(newBeerData.date)
      dateKey = dateKey.valueOf()

      let path = dateKey + '/' + newBeerData.id

      let dataRef = db.ref('data/' + path)
      dataRef.set(newBeerData)
    }
  }
})

function calculateAverage (average) {
  // If average has no value at least we return 0
  let sum = 0

  if (average.length) {
    sum = (_.sum(average) / average.length).toFixed(2)
  }

  return sum
}

function createBreweriesData (data) {
  let breweries = _.groupBy(data, 'brewery')
  let breweryData = []

  for (const brewery in breweries) {
    if (breweries.hasOwnProperty(brewery)) {
      let id = brewery.toLowerCase()
      let beersData = []

      breweries[brewery].forEach(beer => {
        beersData.push({
          name: beer.name,
          average: beer.average
        })
      })

      // Matches any non-word character. Equivalent to [^A-Za-z0-9_].
      id = id.replace(/[\W]+/g, '')
      breweryData.push({
        brewery: breweries[brewery][0].brewery,
        brewery_id: id,
        beers: beersData,
        count: beersData.length
      })

    }
  }

  return breweryData
}

function reorderData (data) {
  let beers = []
  // each date
  _.forOwn(data, function (val1, key1) {
    // each beer, key1 is a date in unix time format like '1487894400000'
    _.forOwn(data[key1], function (beer, key2) {
      let average = []
      let raters = []

      _.find(beer['ratings'], function (obj) {
        average.push(obj.rating)
        raters.push(obj.name.toLowerCase())
      })
      beer.average = calculateAverage(average)
      beer.raters = raters
      beers.push(beer)
    })
  })

  return beers
}
const uniqueArray = arr => [...new Set(arr)]

function getUniqueRaters (data) {
  let raters = []

  for (let i = 0; i < data.length; i++) {
    const element = data[i]

    // If a beer has no ratings it should not be added
    if (element.ratings !== undefined) {
      let users = Object.keys(element.ratings)
      users.forEach(user => {
        raters.push(user)
      })
    }
  }
  raters = uniqueArray(raters)
  raters = _.sortBy(raters, function (el) { return el[0] })

  return raters
}

function countNumbersOfBeers (data) {
  let count = 0
  _.forEach(data, function (value) {
    count += Object.keys(value).length
  })

  return count
}

function filterUniqueBreweries (data) {
  let breweries = []

  // Collect all breweries
  _.forEach(data, function (beer) {
    _.forEach(beer, function (value) {
      breweries.push(value.brewery)
    })
  })

  // Remove duplicates
  breweries = uniqueArray(breweries)

  return breweries
}

export default store
